import React, { useState } from 'react';
import {
  Container,
} from 'react-bootstrap';
import Button from 'components/DesignSystem/Button';
import Form from './Form';

export default function New() {
  const [showForm, setShowForm] = useState(false);

  return (
    <Container className="px-0 mt-2">
      { !showForm && (
        <Button
          icon="add"
          type="tertiary"
          onClick={() => setShowForm(true)}
          className="w-100"
        >
          Nova simulação antiga
        </Button>
      ) }
      { showForm && <Form setShowForm={setShowForm} /> }
    </Container>
  );
}
